import React from 'react';
import {
	FlashbarProps,
} from '@amzn/awsui-components-console';

import GenericWizard from 'src/components/commonComponents/GenericWizard/GenericWizard';
import { generateReviewSectionsFromSteps } from 'src/components/commonComponents/GenericWizard/utils/wizardUtils';

import {
	ApplicationProfileFormMetadata,
	getApplicationWizardSteps,
} from './ApplicationFormGenerationUtils';

interface AddApplicationPageProps {
	onCancel: () => void;
	onSubmit: (data: ApplicationProfileFormMetadata) => void;
	isLoading: boolean;
	flashBarItems?: FlashbarProps.MessageDefinition[];
	error?: string | null;
}

const AddApplicationForm: React.FC<AddApplicationPageProps> = ({
	onCancel,
	onSubmit,
	flashBarItems,
	error,
	isLoading,
}) => {
	return (
		<GenericWizard<ApplicationProfileFormMetadata>
			title="Add Application"
			description="Create a new Application"
			steps={getApplicationWizardSteps()}
			onCancel={onCancel}
			onSubmit={onSubmit}
			isLoading={isLoading}
			errorMessage={error}
			flashBarItems={flashBarItems}
			reviewTitle="Review Application Details"
			submitButtonText="Create Application"
			generateReviewSections={generateReviewSectionsFromSteps}
		/>
	);
};

export default AddApplicationForm;